import {
  Component,
  OnInit,
  HostBinding,
  Input,
  OnChanges,
  Output,
  ViewChild,
  ElementRef,
  EventEmitter,
} from '@angular/core'
import { DomSanitizer } from '@angular/platform-browser'
import { Subscription, Subject } from 'rxjs'
import { debounceTime } from 'rxjs/operators'
import { ContextService } from '../../services'
import { Colors } from '../../common/config/constants'

@Component({
  standalone: false,
  selector: 'app-selectfilter',
  templateUrl: './selectfilter.component.html',
  styleUrls: ['./selectfilter.component.scss'],
})
export class SelectfilterComponent implements OnInit, OnChanges {
  changeEvent = new Subject<void>()
  changeSubscription: Subscription

  @Input() compareMode = false
  @HostBinding('class.compareSelector') get compareSelector() {
    return this.compareMode
  }
  @HostBinding('class.open') showFilter = false
  @HostBinding('class.ready') ready = false
  @HostBinding('class.selected') hasItemSelected = false
  @HostBinding('class.disabled') @Input() disabled = false

  @ViewChild('search', { static: true }) searchInput: ElementRef

  @Input() optTextColor: any = Colors.colorBlack
  @Input() arrowIcon: any = ''
  @Input() title = ''
  @Input() items: any[]
  @Input() canShowClear: boolean

  @Input()
  set value(currentValue) {
    this.filterValue = currentValue
    this.hasItemSelected = false
    if (currentValue) {
      // get full item
      this.filter()
      if (this.filteredItems.length === 1) {
        this.filterValue = this.filteredItems[0]
      }

      this.hasItemSelected = true
    }
  }

  get value() {
    return this.filterValue
  }

  @Output() changeValue = new EventEmitter<string>()
  @Output() onOpen = new EventEmitter<any>()

  filteredItems: any[] = []
  filterValue: any

  constructor(
    private sanitizer: DomSanitizer,
    private context: ContextService,
  ) {}

  ngOnInit() {
    this.changeSubscription = this.changeEvent
      .pipe(debounceTime(100))
      .subscribe((e) => {
        this.filter()
      })

    this.optTextColor = this.sanitizer.bypassSecurityTrustStyle(
      '--opt-text-color: ' + this.optTextColor,
    )
    this.arrowIcon = this.sanitizer.bypassSecurityTrustStyle(
      '--opt-arrow-icon: ' + this.arrowIcon,
    )

    this.setFilteredItems(this.items)
    if (!this.filterValue || this.filterValue.length === 0) {
      this.hasItemSelected = false
    }
  }

  ngOnChanges(changes) {
    if (changes.items && !changes.items.firstChange) {
      this.setFilteredItems(changes.items.currentValue)
    }
  }

  open(e = null) {
    if (this.disabled || this.hasItemSelected) {
      return
    }
    if (e) {
      e.stopPropagation()
      e.preventDefault()
    }
    setTimeout(() => {
      if (!this.compareMode) {
        this.showFilter = true
        this.searchInput.nativeElement.focus()
      } else {
        if (!this.ready) {
          this.ready = true
          this.searchInput.nativeElement.blur()
        } else {
          this.ready = false
          this.showFilter = true
        }
      }
      this.onOpen.emit(this.ready)
    }, 250)
  }

  close() {
    setTimeout(() => {
      this.ready = false
      this.showFilter = false
    }, 250)
  }

  blurClose() {
    if (!this.compareMode) {
      this.close()
    }
  }

  filter() {
    this.hasItemSelected = false
    if (this.items === undefined) {
      return
    }

    this.filteredItems = this.items

    if (
      this.filterValue !== '' &&
      this.filterValue !== undefined &&
      this.filterValue !== null
    ) {
      this.filteredItems = this.items.filter((elem) => {
        return (
          elem.value
            .toString()
            .toLowerCase()
            .includes(this.filterValue.toString().toLowerCase()) ||
          elem.label
            .toString()
            .toLowerCase()
            .includes(this.filterValue.toString().toLowerCase())
        )
      })
    }
  }

  onSearch($event) {
    this.filterValue = $event.currentTarget.value
    this.changeEvent.next()
  }

  selectitem(event, item) {
    this.filterValue = item
    this.hasItemSelected = true
    this.changeValue.emit(this.filterValue)
    this.showFilter = false
  }

  clear(event) {
    if (event) {
      event.preventDefault()
      event.stopPropagation()
    }
    if (this.filterValue !== '') {
      this.filterValue = ''
      this.hasItemSelected = false
      this.changeValue.emit(this.filterValue)
    } else if (!this.showFilter && !this.ready) {
      this.open()
    } else {
      this.close()
    }
  }

  isFilterActive() {
    return this.showFilter
  }

  getPlaceholder() {
    const firstCondition =
      this.filterValue && typeof this.filterValue === 'string'
    return firstCondition
      ? this.filterValue
      : this.filterValue && this.filterValue.label
      ? this.filterValue.label
      : ''
  }

  private setFilteredItems(items) {
    this.items = items
    if (items && items.length && typeof items[0] === 'string') {
      this.items = items.map((elem) => ({ value: elem, label: elem }))
    }
    this.filteredItems = this.items
  }

  canClear() {
    return this.canShowClear || this.context.canClearPoi()
  }
}
